module.exports = __webpack_public_path__ + "img/bg-login.614ed625.png";